import angular from 'angular'
import directive from './directive'
import quickPickInlineHumanize from './filter.quickPickInlineHumanize'

export default angular
  .module('ellipsis.calendarControl', [])
  .filter('quickPickInlineHumanize', quickPickInlineHumanize)
  .directive('calendarControl', directive)
